import Constants from '../Constants.js';
import * as Util from './util.js';

/**
 * @param {object} query
 * @param {object} query.api an api object
 * @param {string} query.type 
 * @param {string} query.mode
 * @param {string} query.obj
 * @returns {function} 
 */
// TODO: I don't like this
function defaultGetApiQueryable({
  api,
  type,
  mode,
  obj
}) {
  // type is device, system, or project
  let toReturn = api[type];

  // we need to pass in the device, system or project
  toReturn = toReturn(obj);

  // if its not the device, we need to hit device().events or device().history
  if (type !== 'device') {
    toReturn = toReturn.device();
  }

  // mode is events or history
  toReturn = toReturn[mode];

  // if its events we need to list because it has other actions
  if (mode !== 'history') {
    toReturn = toReturn().list;
  }

  // this should be a function to call with query opts
  return toReturn;
}

/**
 * @param {object} query
 * @param {string} query.mode
 * @param {object} query.getApiQueryable
 * @param {string} query.chunkTime 
 * @returns {function} install function
 */
function create({
  mode,
  getApiQueryable = defaultGetApiQueryable,
  chunkTime = 1000 * 60 * 60 * 24
}) {
  /**
   * @param {object} keys
   * @param {string} keys.reduxKey
   * @returns {object} contains several methods
   */
  return function install({
    reduxKey = 'query'
  }) {
    /**
     * @param {array} chunks 
     * @param {object} item 
     * @returns {object} 
     */
    function getChunk(chunks, item) {
      let index;
      const nChunk = chunks.find((chunk, i) => {
        const iTime = new Date(item.time);
        const start = new Date(chunk.start);
        const end = new Date(chunk.end);
        if (iTime >= start && iTime <= end) {
          index = i;
          return true;
        }
        return false;
      });
      return {
        index,
        chunk: nChunk,
        time: new Date(item.time).getTime()
      };
    }
    /**
     * @param {object} opts 
     * @returns redux thunk function
     */
    function query(opts) {
      return async function queryAction(dispatch, getState, {
        api
      }) {
        const state = getState() && getState()[reduxKey],
          lastQueried = Date.now();
        const {
          queryName,
          query,
          queryable,
          optimize = Constants.QUERY_OPTIMIZE_QUERY
        } = opts;
        let {
          pagination
        } = opts;
        if (!pagination) {
          pagination = {
            startIndex: 0,
            perPage: 1000
          };
        }
        const name = queryName || query.name;
        let queryOpts;
        if (state.queries && state.queries[name]) {
          queryOpts = state.queries[name];
        } else {
          dispatch(addQuery({
            name,
            query
          }));
          queryOpts = query;
        }
        /*
        if simple
          break query out by day
           if we have the time of data point 99 or 100
            pick the right day
          else
            get initial n data points 0->200 from day 0
           while less than 200 data points and in query range
            go to next day get 0->(200 - n) data points
            
          put all data points in redux
         if not simple
          run full query unchunked
        */
        dispatch({
          type: Util.getActionConstant(Constants.START_QUERY, mode),
          queryable,
          queryName: name
        });
        if (Util.isSimpleTimeQuery(queryOpts) && optimize !== Constants.QUERY_OPTIMIZE_DOWNLOAD) {
          let chunks = Util.getQueryChunks(queryOpts, chunkTime);
          const {
            startIndex,
            perPage
          } = pagination;
          let aIndex = 0,
            aPerPage = perPage,
            leftToGet = perPage,
            aStartIndex = startIndex;
          if (state.results && state.results[name] && state.results[name].items && (state.results[name].items[startIndex] || state.results[name].items[startIndex - 1])) {
            const {
              index,
              time
            } = getChunk(chunks, state.results[name].items[startIndex] || state.results[name].items[startIndex - 1]);
            chunks = chunks.slice(index);
            if (Util.isReversed) {
              chunks[0] = {
                ...chunks[0],
                end: time - 1
              };
            } else {
              chunks[0] = {
                ...chunks[0],
                start: time + 1
              };
            }
          } else {
            aPerPage = startIndex + perPage;
            leftToGet = startIndex + perPage;
            aStartIndex = 0;
          }
          const qItems = [];
          while (qItems.length < aPerPage && aIndex < chunks.length) {
            const qOpts = {
              ...opts,
              query: chunks[aIndex],
              pagination: {
                startIndex: 0,
                perPage: leftToGet
              }
            };
            const {
              error,
              results
            } = await queryChunk(qOpts, api);
            if (error) {
              // TODO dispatch query fail :(
              dispatch({
                type: Util.getActionConstant(Constants.QUERY_ERROR, mode),
                error,
                queryName: name
              });
              return {
                error,
                results: null
              };
            }
            qItems.push(...results.items);
            leftToGet -= results.items.length;
            if (leftToGet > 0) {
              aIndex++;
            }
          }
          let rItems = qItems,
            rPagination = {
              startIndex,
              perPage
            };
          // this means we didn't have the starter :(
          if (aPerPage !== perPage && startIndex !== aStartIndex) {
            rItems = rItems.slice(startIndex);
            rPagination = {
              startIndex: 0,
              perPage: startIndex + perPage
            };
          }

          // TODO dispatch query success
          dispatch({
            type: Util.getActionConstant(Constants.QUERY_SUCCESS, mode),
            results: {
              ...query,
              items: qItems,
              ...rPagination
            },
            queryName: name,
            lastQueried
          });
          return {
            error: null,
            results: rItems
          };
        }
        const nOpts = {
          query: queryOpts,
          ...opts
        };
        const {
          error,
          results
        } = await queryChunk(nOpts, api);
        if (error) {
          // TODO dispatch query fail :(
          dispatch({
            type: Util.getActionConstant(Constants.QUERY_ERROR, mode),
            error,
            queryName: name
          });
          return {
            error,
            results: null
          };
        }
        dispatch({
          type: Util.getActionConstant(Constants.QUERY_SUCCESS, mode),
          results,
          queryName: name,
          lastQueried
        });
        return {
          error,
          results
        };
      };
    }

    /**
     * @param {function | object} getState current state or function that returns the current state
     * @returns queries for the parent provided reduxKey
     */
    function getQueries(getState) {
      if (typeof getState === 'function') {
        return getState && getState && getState()[reduxKey] && getState()[reduxKey].queries;
      }
      return getState && getState[reduxKey] && getState[reduxKey].queries;
    }

    /**
     * @param {function | object} getState current state or function that returns the current state
     * @returns result for the parent provided reduxKey
     */
    function getResults(getState) {
      if (typeof getState === 'function') {
        return getState && getState && getState()[reduxKey] && getState()[reduxKey].results;
      }
      return getState && getState[reduxKey] && getState[reduxKey].results;
    }

    /**
     * @param {object} opts query options
     * @param {object} api represents an api object
     * @returns {object} object with results and errors keys
     */
    async function queryChunk(opts, api) {
      const {
        query,
        queryable,
        pagination
      } = opts;
      const {
        startIndex = 0,
        perPage = 1000
      } = pagination || {};

      // we need to know if were querying a device, system, or project
      const {
        type,
        ...rest
      } = query; // Util.getQueryOptions( query, chunkTime )
      /*
        this returns a function to call that will get events
        e.g. api.project( queryable ).device().events().list or api.device( queryable ).history
      */
      const queryFunc = getApiQueryable({
        api,
        type,
        mode,
        queryable
      });
      let results, error;
      try {
        results = await queryFunc({
          ...rest,
          startIndex,
          perPage
        });
      } catch (ex) {
        error = ex;
      }
      return {
        error,
        results
      };
    }

    /**
     * @param {object} opts 
     * @returns {object} 
     */
    function addQuery(opts = {}) {
      const {
        name,
        query
      } = opts;
      return {
        type: Util.getActionConstant(Constants.ADD_QUERY, mode),
        query,
        name
      };
    }

    /**
     * @param {object} opts 
     * @returns {object} 
     */
    function updateQuery(opts = {}) {
      const {
        name,
        query
      } = opts;
      return {
        type: Util.getActionConstant(Constants.UPDATE_QUERY, mode),
        query,
        name
      };
    }
    // function getQuery( state, name ) {
    //   return state && state.queries && state.queries[name]
    // }

    /**
     * @param {string} name 
     * @returns {object} 
     */
    function deleteQuery(name) {
      return {
        type: Util.getActionConstant(Constants.DELETE_QUERY, mode),
        name
      };
    }

    /**
     * @param {string} constant
     * @returns {string} 
     */
    function getActionConstantByName(constant) {
      return Util.getActionConstant(constant, mode);
    }
    return {
      query,
      queryChunk,
      addQuery,
      updateQuery,
      deleteQuery,
      getQueries,
      getResults,
      reduxKey,
      // getQuery,
      getActionConstantByName
    };
  };
}
export default {
  create
};